import { render } from "./_EditarArquivo.vue?vue&type=template&id=b380651c"
import script from "./_EditarArquivo.vue?vue&type=script&lang=ts"
export * from "./_EditarArquivo.vue?vue&type=script&lang=ts"
script.render = render

export default script